import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const createFeedPost = (formData) =>
	Http.post('/feed-publisher/posts', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const getFeedPosts = (params = {}) =>
	Http.get(`/feed-publisher/posts${serialize(params)}`)

export const deleteFeedPost = (id) =>
	Http.delete(`/feed-publisher/posts/${id}`)
